import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';

import { IMultiSelectOption, IMultiSelectSettings, IMultiSelectTexts } from 'ngx-bootstrap-multiselect';
import { CrossSell, crossSellSem, crossSellCom, crossSellObrigatorio } from '../../cross-sell';

@Component({
    selector: 'sgt-cross-sell-multiselect',
    templateUrl: './cross-sell-multiselect.component.html',
    styleUrls: ['./cross-sell-multiselect.component.less']
})
export class CrossSellMultiselectComponent implements OnInit {
    /** Cross Sells selecionados */
    @Input() crossSells: number[];
    /** Ao alterar a seleção dos cross sells */
    @Output() crossSellsChange = new EventEmitter<number[]>();

    // Settings
    settings: IMultiSelectSettings;
    @Input() pullRight = false;
    @Input() enableSearch = false;
    @Input() showCheckAll = true;
    @Input() showUncheckAll = true;
    @Input() dynamicTitleMaxItems = 0;
    @Input() fixedTitle = false;
    /** Se deve exibir o multiselect acima */
    @Input() dropup = false;
    /** Se deve desabilitar o multiselect */
    @Input() disabled = false;

    // Texts
    texts: IMultiSelectTexts;
    @Input() checkAll = 'Selecionar Todas';
    @Input() uncheckAll = 'Limpar';
    @Input() defaultTitle = 'Nenhuma Opção';
    @Input() checked = 'Cross Sell'
    @Input() checkedPlural = 'Cross Sell';
    @Input() searchPlaceholder = 'Pesquisar...';
    @Input() allSelected = 'Todos Selecionados';
    @Input() searchEmptyResult = 'Nenhuma Cross Sell encontrado';
    @Input() searchNoRenderText = 'Digite para pesquisar';

    @Input() isShowSem = true;
    @Input() isShowCom = true;
    @Input() isShowObrigatorio = true;

    // Options
    options: IMultiSelectOption[];

    ngOnInit() {
        // Settings
        this.settings = {
            pullRight: this.pullRight,
            enableSearch: this.enableSearch,
            containerClasses: `container-multiselect container-multiselect-cross-sell ${this.dropup ? 'dropup' : 'dropdown'}`,
            showCheckAll: this.showCheckAll,
            showUncheckAll: this.showUncheckAll,
            dynamicTitleMaxItems: this.dynamicTitleMaxItems,
            fixedTitle: this.fixedTitle,
        };
        // Texts
        this.texts = {
            checkAll: this.checkAll,
            uncheckAll: this.uncheckAll,
            defaultTitle: this.defaultTitle,
            checked: this.checked,
            checkedPlural: this.checkedPlural,
            searchPlaceholder: this.searchPlaceholder,
            allSelected: this.allSelected,
            searchEmptyResult: this.searchEmptyResult,
            searchNoRenderText: this.searchNoRenderText
        };

        this.create();
    }

    /** Cria as origens para o multiselect */
    private create() {
        this.options = [];
        const selects: IMultiSelectOption[] = [];

        // Sem
        if (this.isShowSem) {
            selects.push({
                id: crossSellSem.id,
                name: crossSellSem.abreviacao,
                classes: 'multiselect-item-cross-sell multiselect-item-cross-sell-sem'
            });
        }

        // Com
        if (this.isShowCom) {
            selects.push({
                id: crossSellCom.id,
                name: crossSellCom.abreviacao,
                classes: 'multiselect-item-cross-sell multiselect-item-cross-sell-com'
            });
        }

        // Obrigatório
        if (this.isShowObrigatorio) {
            selects.push({
                id: crossSellObrigatorio.id,
                name: crossSellObrigatorio.abreviacao,
                classes: 'multiselect-item-cross-sell multiselect-item-cross-sell-obrigatorio'
            });
        }

        this.options = selects;
    }

    /** Ao alterar a seleção dos Cross Sells */
    onChange() {
        this.crossSellsChange.emit(this.crossSells);
    }
}
